/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}.placeholder-container[_ngcontent-%COMP%]{padding:12px 15px}.top-exposure-section[_ngcontent-%COMP%]{padding:12px 25px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/top-exposures/top-exposures.component.scss.shim.ngstyle.js.pre-build-optimizer.js